export type FiltersWithStatus = {
    filters: {
        keywords: string[];
        dropdowns: {
            status: {
                keys: string[];
                asKeyword: boolean;
            };
        }
    };
}


export const defaultFiltersWithStatus : FiltersWithStatus = {
    filters: {
        keywords: [],
        dropdowns: {
            status: {
                keys: [],
                asKeyword: false
            }
        }
    }
};
